/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable max-len */
import React, { useState , useEffect } from 'react';
import './checkin.css';
import { Grid, Rating } from '@mui/material';
import axios from 'axios';

import { useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import SimpleForm from './SimpleForm';
import ThankYouPage from '../WriteReview/ThankYouPage';
import Loader from '../../Loader';
import Header from '../../Header';

function CheckIn({ baseURL }) {
  const { companyid } = useParams();
  // console.log(companyid, 'prams');
  const [page, setPage] = useState(1);
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [assistedBy, setAssistedBy] = useState('');
  const [ReferredBy, setReferredBy] = useState({
    code: '',
    email: '',
    phone: '',
  });
  const [agreeToggle, setAgreeToggle] = useState(false);

  const [companyRating, setCompanyRating] = useState(0);
  const [data, setData] = useState(null);
  const [users, setUsers] = useState([]);
  const [status, setStatus] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getCheckInDetails();
    getAllUsers();
  }, [companyid]);

  const getCheckInDetails = async () => {
    setLoading(true);
    const response = await axios.get(`${baseURL}/dashboard-review/check-in/${companyid}`,{
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
      }, 
    });
    if (response?.data?.status === 'success') {
      setData(response?.data?.data);
      setCompanyRating(response?.data?.data.rating_average);
      setLoading(false);
    }
    if (response?.data?.status === 'failure') {
      setStatus(false);
    }
  };

  const getAllUsers = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${baseURL}/dashboard/user-unauthenticated-get-all/${companyid}`,{
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',
        }, 
      });
      const filterUser = res?.data?.data?.entity;
      const AssignLabel = filterUser.filter((entry) => !(entry?.role === 'Km' || entry?.role === 'System'));
      setUsers(AssignLabel);
      setLoading(false);
    } catch (err) {
      console.log('getAllUsers err', err);
    }
  };

  const handleSubmit = async () => {
    const formData = {
      first_name: name,
      phone: `+1${phone}`,
      email,
      assisted_by: assistedBy,
      referred_by: ReferredBy,
      is_customer_agreed: agreeToggle,
    };

    const response = await axios.post(
      `${baseURL}/dashboard-review/check-in-create/${companyid}`,
      formData,
    );
      
    if (response?.data?.status === 'success') {
      // console.log(response, "handleSubmit res");
      setPage(page + 1);
    }  
    if (response?.data?.status === 'failure') {
      toast.error(response.data.message);
      console.log('handleSubmit err', response);
    }
  };

  if (loading) {
    return <Loader />;
  }
  return (
    <div className="qs-page">
      <div className="qs-card">
        <div>
          { data && (
            <div className="border-b border-slate-100">
              <Header 
                logo={data?.logo}
                headerColor="#fff"
                headerTextColor="#000"
                companyName={data?.company?.name}
                ratingValue={(data.rating_average === null ? null : Number(Math.round((data?.rating_average) * 10) / 10))}
                reviewCount={data?.review_count}
              />
            </div>
          )}

          {page === 1 && (
          <>
            <div>
              <div className="qs-title px-6 pt-8 sm:px-10 sm:pt-10">Add contact information</div>
            </div>
            <div className="flex items-center justify-center px-6 pb-8 pt-6 sm:px-10 sm:pb-10">
              <SimpleForm
                name={name}
                setName={setName}
                phone={phone}
                setPhone={setPhone}
                email={email}
                setEmail={setEmail}
                assistedBy={assistedBy}
                setAssistedBy={setAssistedBy}
                ReferredBy={ReferredBy}
                setReferredBy={setReferredBy}
                agreeToggle={agreeToggle}
                setAgreeToggle={setAgreeToggle}
                handleSubmit={handleSubmit}
                data={data}
                users={users}
                companyid={companyid}
              />
            </div>
          </>
          )}
          <div>
            {page === 2 && (
              <ThankYouPage 
                baseURL={baseURL}
                value={data}
                companyId={companyid}
              />
            )}

          </div>
        </div>
      </div>
    </div>
  );
}

export default CheckIn;
